module.exports = __webpack_public_path__ + "assets/media/help_center_link_icon.1f3f78ff.svg";